<template>
    <div class="f-icon-reply" @click="reply">
        <img :src="icon" class="f-icon-reply-img">
        <span class="f-icon-reply-word">{{boardInfo.id === 1 ? '回答' : '回复'}}</span>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/icon/reply-icon.less';
</style>

<script>
import {mapState} from 'vuex';
export default {
    data() {
        return {
            icon: require('@/assets/images/icon-reply/reply.png')
        };
    },
    computed: {
        ...mapState({
            boardInfo: state => state.topicContent.topicData.boardInfo
        })
    },
    methods: {
        reply() {
            this.$emit('reply');
        }
    }
};
</script>
